import { gql } from "@apollo/client"; import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react"; import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useForm } from '../../../components/hooks/useForm';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import KeyIcon from '@mui/icons-material/Key';
import PeopleIcon from '@mui/icons-material/People';
import { GetDescripcionMensaje } from '../../../helpers/tools';
import HelpIcon from '@mui/icons-material/Help';
import ErrorDialog from '../../../components/ErrorDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Outlet, useNavigate } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import toast, { Toaster } from 'react-hot-toast';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function UsuariosAll() {

  const [datos, setDatos] = useState('');
  const [dataOriginal, setDataOriginal] = useState('');

  const [openDlgAuth, setOpenDlgAuth] = useState(false);
  const [openDlgPass, setOpenDlgPass] = useState(false);
  const [openConfirmacion, setOpenConfirmacion] = useState(false);
  const [loadingAceptar, setLoadingAceptar] = useState(false);
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [usuariosAuth, setUsuariosAuth] = useState('');
  const [dataOriginalAuth, setDataOriginalAuth] = useState('');
  const [usuarioId, setUsuarioId] = useState(0);
  const [usuarioidAuth, setUsuarioIdAuth] = useState(0);

  const [usuarioAuth, setUsuarioAuth] = useState({
    Id: 0,
    Usuario: '',
    Clave: '',
    Nombre: '',
    Email: '',
    IdUsuario: 0
  });

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const [usuarioNH, setUsuarioNH] = useState({
    Usuario: ''
  });

  const [state, setState] = useState({
    ShowPass: false
  });
  const handleClickShowPassword = () => {
    setState({
      ...state,
      ShowPass: !state.ShowPass
    });
  };

  const txtBuscar = useRef(null);
  const txtBuscarAuth = useRef(null);

  const [formPassValues, formPassHandle, setFormPassValues] = useForm({
    password: ''
  });

  useEffect(() => {
    txtBuscar.current.focus();
    getUsuariosNH();
  }, []);

  const QGetUsuariosNH = gql`
        query QGetUsuariosNH{
            usuarios
                {
                    success,
                    error,
                    valorEsperado {
                        idUsuario,
                        usuario,
                        nombre,
                        apellido,
                        email,
                        idUsuarioAuth
                    }
                }
        }`;

  const [getUsuariosNH, { data: dataUsuariosNH }] = useLazyQuery(QGetUsuariosNH, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataUsuariosNH?.usuarios.success) return;

    const dataAll = dataUsuariosNH.usuarios.valorEsperado;
    setDatos(dataAll);
    setDataOriginal(dataAll);
  }, [dataUsuariosNH]);

  const QGetUsuariosByApp = gql`
        query QGetUsuarios($usuario: String!, $clave: String!){
            usuariosByApp(model: { usuario: $usuario, clave: $clave })
                {
                    success,
                    error,
                    valorEsperado {
                        id,
                        usuario,
                        nombre,
                        apellido,
                        email
                    }
                }
        }`;

  const [getUsuariosByApp, { loading, error: errorUsuarios, data: dataAuth }] = useLazyQuery(QGetUsuariosByApp, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataAuth) return;
    if (dataAuth.usuariosByApp?.success) {
      setOpenDlgPass(false);
      setOpenDlgAuth(true);

      setUsuariosAuth(dataAuth.usuariosByApp.valorEsperado);
      setDataOriginalAuth(dataAuth.usuariosByApp.valorEsperado);
    } else {
      let descripcionError = GetDescripcionMensaje(dataAuth.usuariosByApp.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataAuth.usuariosByApp.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else if (dataAuth.usuariosByApp.error === 'ERRORDB' || parseInt(dataAuth.usuariosByApp.error, 10) > 0) {
        setMensajeError(dataAuth.usuariosByApp.error);
      } else {
        setMensajeError("ERRORDB");
      }
    }
  }, [dataAuth]);

  useEffect(() => {
    if (errorUsuarios) {
      setMensajeError("ERRORDB");
    }
  }, [errorUsuarios]);

  const MVincularUsuario = gql`
    mutation MVincularUsuario($idUsuario: Int!, $nombre: String!, $apellido: String!, $email: String!, $usuario: String!, $id: Int! ){    
        vincularUsuario(model: { nombre: $nombre, apellido: $apellido, email: $email, usuario: $usuario, id: $id, idUsuario: $idUsuario  }) 
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const [vincularUsuario, { vinculoData }] = useMutation(MVincularUsuario, {
    onCompleted: (vinculoData) => {
      if (vinculoData.vincularUsuario.success) {
        if (vinculoData.vincularUsuario.valorEsperado) {
          setOpenDlgAuth(false);
          setLoadingAceptar(false);
          setOpenConfirmacion(false);
          getUsuariosNH();
          toast.success("El usuario se vinculó correctamente.");
          setFormPassValues({
            ...formPassValues,
            password: ''
          });
        } else {
          setLoadingAceptar(false);
          toast.error(vinculoData.vincularUsuario.error);
        }
      } else {
        let descripcionError = GetDescripcionMensaje(vinculoData.vincularUsuario.error);
        if (isNaN(descripcionError)) {
          let mensaje = `${vinculoData.vincularUsuario.error} - ${descripcionError}`;
          toast.error(mensaje);
        } else if (vinculoData.vincularUsuario.error === 'ERRORDB' || parseInt(vinculoData.vincularUsuario.error, 10) > 0) {
          setMensajeError(vinculoData.vincularUsuario.error);
        } else {
          setMensajeError("ERRORDB");
        }
      }
    },
    onError: (vinculoData) => {
      setLoadingAceptar(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleCloseDlgAuth = () => {
    setOpenDlgAuth(false);
    setFormPassValues({
      ...formPassValues,
      password: ''
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleAceptar();
    }
  };

  const handleClick = () => {
    const usuario = sessionStorage.getItem('usuario');
    let result = getUsuariosByApp({ variables: { usuario: usuario, clave: formPassValues.password } });
  };

  const handleAceptar = () => {
    if (isFormValid()) {
      handleClick();
    }
  };

  const isFormValid = () => {
    if (formPassValues.password.length === 0) {
      toast.error("Debe ingresar su contraseña");
      return false;
    }

    return true;
  };

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscar.current.value != "") {
      if (txtBuscar.current.value.length >= 3) {
        setDatos(dataOriginal.filter((dataOriginal) => {
          const usuarioBuscar = dataOriginal.usuario.toLowerCase();
          const nombreBuscar = dataOriginal.nombre.toLowerCase();
          const apellidoBuscar = dataOriginal.apellido.toLowerCase();
          const emailBuscar = dataOriginal.email.toLowerCase();

          const inputBuscar = txtBuscar.current.value.toLowerCase();
          return (
            usuarioBuscar.includes(inputBuscar) ||
            nombreBuscar.includes(inputBuscar) ||
            apellidoBuscar.includes(inputBuscar) ||
            emailBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      getUsuariosNH();
    }
  };

  const handleSearchAuth = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscarAuth.current.value != "") {
      if (txtBuscarAuth.current.value.length >= 3) {
        setUsuariosAuth(dataOriginalAuth.filter((dataOriginalAuth) => {
          const usuarioBuscar = dataOriginalAuth.usuario.toLowerCase();
          const nombreBuscar = dataOriginalAuth.nombre.toLowerCase();
          const apellidoBuscar = dataOriginalAuth.apellido.toLowerCase();
          const emailBuscar = dataOriginalAuth.email.toLowerCase();

          const inputBuscar = txtBuscarAuth.current.value.toLowerCase();
          return (
            usuarioBuscar.includes(inputBuscar) ||
            nombreBuscar.includes(inputBuscar) ||
            apellidoBuscar.includes(inputBuscar) ||
            emailBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      const usuario = sessionStorage.getItem('usuario');
      getUsuariosByApp({ variables: { usuario: usuario, clave: formPassValues.password } });
    }
  };

  const handleSearchKey = (e) => {
    // enter
    if (e.keyCode == 13) {
      handleSearch();
    }
  };

  const handleClean = () => {
    txtBuscar.current.value = "";
    handleSearch();
    txtBuscar.current.focus();
  };

  const handleCleanAuth = () => {
    txtBuscarAuth.current.value = "";
    handleSearchAuth();
    txtBuscarAuth.current.focus();
  };

  const onCloseDlgPass = () => {
    setOpenDlgPass(false);
  };

  const handleEdit = (row) => {
    setOpenDlgPass(true);
    setUsuarioId(row.idUsuario);

    setUsuarioNH((prevState) => {
      return {
        ...prevState,
        Usuario: row.usuario
      };
    });
  };

  // Click sobre fila de la grilla de búsqueda de usuarios Auth
  const handleRowClick = (params) => {

    setUsuarioAuth((prevState) => {
      return {
        ...prevState,
        Id: params.row.id,
        Apellido: params.row.apellido,
        Nombre: params.row.nombre,
        Usuario: params.row.usuario,
        Email: params.row.email,
        IdUsuario: usuarioId
      };
    });

    setOpenConfirmacion(true);
  };

  const handleAceptarDlg = () => {
    setLoadingAceptar(true);

    let result = vincularUsuario({
      variables: {
        idUsuario: usuarioId,
        nombre: usuarioAuth.Nombre,
        apellido: usuarioAuth.Apellido,
        email: usuarioAuth.Email,
        usuario: usuarioAuth.Usuario,
        id: usuarioAuth.Id
      }
    });
  };

  const handleCancelarDlg = () => {
    setOpenConfirmacion(false);
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const initialUserColumns = [
    { field: 'idUsuario', headerName: 'Id' },
    { field: 'usuario', headerName: 'Usuario' },
    { field: 'apellido', headerName: 'Apellido' },
    { field: 'nombre', headerName: 'Nombre' },
    { field: 'email', headerName: 'Email', flex: 0.4 },
    {
      headerName: 'Acciones',
      renderCell: (params) => {
        let id = params.row.idUsuarioAuth;

        return id > 0 ?

          <>
            <PeopleIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              onClick={() => handleEdit(params.row)}
              titleAccess='Revincular Usuario' />

          </> :

          <>
            <InsertLinkIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              onClick={() => handleEdit(params.row)}
              titleAccess='Vincular Usuario' />

          </>;
      }
    }];


  const initialAuthUserColumns = [
    { field: 'id', headerName: 'Id' },
    { field: 'usuario', headerName: 'Usuario' },
    { field: 'apellido', headerName: 'Apellido' },
    { field: 'nombre', headerName: 'Nombre' },
    { field: 'email', headerName: 'Email', flex: 0.4 }];


  const userColumns = useMemo(() => generateColumnsDefaultConfiguration(initialUserColumns), []);
  const authUserColumns = useMemo(() => generateColumnsDefaultConfiguration(initialAuthUserColumns), []);

  return (
    <>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box className='botonera-superior-left-search'>
          <TextField
            className="input-300"
            label="Filtrar usuarios"
            name="txtBuscar"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtBuscar}
            onKeyUp={handleSearch}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />

                  <ClearIcon
                    onClick={handleClean}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Box>
      </Stack>
      <br />

      <DataGridGenerico
        columns={userColumns}
        fileNameExport='Usuarios'
        rows={datos}
        toolbar={false} />


      {/* Usuarios Auth */}
      <Dialog
        maxWidth="lg"
        fullWidth="true"
        open={openDlgAuth}>

        <DialogTitle>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '30px', paddingTop: '5px' }}><PersonSearchIcon /></div>
            <div style={{ fontSize: '13pt', paddingTop: '5px' }}>Búsqueda de Usuarios Auth</div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ fontSize: '13pt' }}>
              <FormControl sx={{ backgroundColor: 'white' }} size="small">
                <div style={{ display: 'flex', width: '100%' }}>
                  <TextField
                    className="input-300"
                    label="Filtrar usuarios"
                    name="txtBuscarAuth"
                    size="small"
                    type="text"
                    variant="outlined"
                    inputRef={txtBuscarAuth}
                    onKeyUp={handleSearchAuth}
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          <SearchIcon
                            onClick={handleSearchAuth}
                            sx={{ cursor: 'pointer' }} />

                          <ClearIcon
                            onClick={handleCleanAuth}
                            sx={{ cursor: 'pointer' }} />

                        </InputAdornment>

                    }} />

                </div>
              </FormControl>
            </div>
          </div>

          <br />

          <DataGridGenerico
            columns={authUserColumns}
            rows={usuariosAuth}
            toolbar={false}
            onRowClick={handleRowClick} />


        </DialogContent>
        <DialogActions>
          <Button
            endIcon={<CheckIcon />}
            onClick={handleCloseDlgAuth}
            size='small'
            variant="contained">

            Cerrar
          </Button>
        </DialogActions>
      </Dialog>


      {/* Dialog Contraseña */}
      <Dialog
        maxWidth="sm"
        fullWidth="true"
        open={openDlgPass}>

        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onCloseDlgPass}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>

            <CloseIcon />
          </IconButton>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '30px', paddingTop: '5px' }}><KeyIcon /></div>
            <div style={{ fontSize: '13pt', paddingTop: '5px' }}>Ingrese su contraseña</div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ fontSize: '13pt' }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  name='password'
                  label="Contraseña"
                  inputProps={{ style: { textAlign: 'center' } }}
                  placeholder="Contraseña"
                  value={formPassValues.password}
                  onChange={formPassHandle}
                  onKeyDown={handleKeyDown}
                  type={state.ShowPass ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end">

                        {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>}
                  fullWidth required />

              </FormControl>
            </div>
          </div>

        </DialogContent>
        <DialogActions>
          <CustomButton
            endIcon={<CheckIcon />}
            onClick={handleAceptar}
            size='small'
            variant="contained">

            Aceptar
          </CustomButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Confirmacion */}
      <Dialog
        maxWidth="md"
        open={openConfirmacion}>

        <DialogTitle>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ color: '#0063BE', width: '35px', paddingTop: '5px' }}><HelpIcon /></div>
            <div style={{ fontSize: '13pt', paddingTop: '5px' }}>Confirmación de modificación</div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ fontSize: '11pt' }}>
              <strong>¿Está seguro de vincular el usuario?. </strong>
              <br /><br />
              Se va a vincular el usuario <strong>{usuarioAuth.Usuario}</strong> del sistema <strong>Autenticador</strong>
              &nbsp;con el usuario <strong>{usuarioNH.Usuario}</strong> correspondiente a <strong>NH</strong>
              <br /><br />
              Pulse <strong>Aceptar</strong> en caso de confirmar los cambios o <strong>Cancelar</strong> en caso contrario.
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <CustomButton
            loading={loadingAceptar}
            variant="contained"
            onClick={handleAceptarDlg}
            endIcon={<CheckIcon />}
            size="small">

            Aceptar
          </CustomButton>
          <Button
            color='error'
            endIcon={<CloseIcon />}
            onClick={handleCancelarDlg}
            size='small'
            variant="contained">

            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <Outlet />



      <ErrorDialog
        id="dlg-error-terminos"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


    </>);


}